var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ReportStatusTable',{attrs:{"is-example":"","per-page":_vm.exampleList.length,"rows-per-page":_vm.rowsPerPage,"table-data":_vm.exampleList,"total-records":_vm.exampleList.length}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }